//当前这个模块：API进行统一管理
import requests from './request';
//注册用户
export const reqRegister= (data) =>{
return requests({url:'/api/reguser',data,method:'post'})
}
//登录
export const reqLogin= (data) =>{
return requests({url:'/api/login',data,method:'post'})
}
/*首页*/
//获取首页信息
export const getHomeList= () =>{
return requests({url:'/manage/home',method:'get'})
}
//新增信息
export const addHomeData= ({data}) =>{
return requests({url:'/manage/home/add',data,method:'post'})
}
//根据id获取信息
export const byIdHome= (id) =>{
return requests({url:`/manage/home/byid/${id}`,method:'get'})
}
//根据id更新数据
export const updateByHome= ({data}) =>{
return requests({url:'/manage/home/update',data,method:'put'})
}
//删除数据
export const delHome= (id) =>{
return requests({url:`/manage/home/delete/${id}`,method:'delete'})
}
/*首页分类信息*/
//获取所有分类信息
export const getHomeCateAll= ({params}) =>{
return requests({url:'/manage/homecateall',params,method:'get'})
}
//根据男女分类获取不同信息
export const getHomeCate= (id) =>{
return requests({url:`/manage/homecate/${id}`,method:'get'})
}
//新增信息
export const addHomeCateData= ({data}) =>{
return requests({url:'/manage/homecate/add',data,method:'post'})
}
//根据id获取信息
export const byIdHomeCate= (id) =>{
return requests({url:`/manage/homecate/byid/${id}`,method:'get'})
}
//根据id更新数据
export const updateByHomeCate= ({data}) =>{
return requests({url:'/manage/homecate/update',data,method:'put'})
}
//删除数据
export const delHomeCate= (id) =>{
return requests({url:`/manage/homecate/delete/${id}`,method:'delete'})
}
/*个人中心*/
//获取用户基本信息
export const getuserinfo= () =>{
return requests({url:'/my/userinfo',method:'get'})
}
//更新用户信息
export const updataUserInfo= (data) =>{
return requests({url:'/my/userinfo',data,method:'post'})
}
//更换头像
export const avatar = ({data}) =>{
return requests({url:'/my/update/avatar',data,method:'post'})
}
//修改密码
export const changePassword = (data) =>{
return requests({url:'/my/updatepwd',data,method:'post'})
}
//----------------------------------------------------------------------------
/*菜单路由*/
//获取不同的菜单路由
export const getMenu= () =>{
return requests({url:'/manage/myMenu',method:'get'})
}
//所有菜单栏信息
export const getAllMenu= () =>{
return requests({url:'/manage/allMenu',method:'get'})
}
//新增菜单栏
export const addMenu= (data) =>{
return requests({url:'/manage/addmenu',data,method:'post'})
}
//根据id获取菜单栏信息
export const byIdGetMenu= (id) =>{
return requests({url:`/manage/byidmenu/${id}`,method:'get'})
}
//编辑菜单栏信息
export const editMenu= (data) =>{
return requests({url:'/manage/editmenu',data,method:'put'})
}
//删除菜单栏
export const delMenu= (id) =>{
return requests({url:`/manage/deletemenu/${id}`,method:'delete'})
}
/*用户列表*/
//获取用户列表
export const getuserList= ({params}) =>{
return requests({url:'/manage/userlist',params,method:'get'})
}
//保存用户所选的角色
export const saveroles= ({data}) =>{
return requests({url:'/manage/saverole',data,method:'post'})
}
//根据id获取用户信息
export const byIduser= (id) =>{
return requests({url:`/manage/byiduser/${id}`,method:'get'})
}
//编辑用户表单
export const editUser= ({data}) =>{
return requests({url:'/manage/edituser',data,method:'put'})
}
//删除用户
export const delUser= (id) =>{
return requests({url:`/manage/deluser/${id}`,method:'delete'})
}
//更新用户状态
export const updateState= ({data}) =>{
return requests({url:'/manage/updatestate',data,method:'put'})
}
//保存用户所选的视图
export const saveView= ({data}) =>{
return requests({url:'/manage/saveview',data,method:'post'})
}
/*角色列表*/
//获取角色列表
export const getrolesList= () =>{
return requests({url:'/manage/roleslist',method:'get'})
}
//新增角色
export const addroles= (data) =>{
return requests({url:'/manage/addroles',data,method:'post'})
}
//根据id获取角色信息
export const byIdroles= (id) =>{
return requests({url:`/manage/byidroles/${id}`,method:'get'})
}
//编辑角色信息
export const editRoles= (data) =>{
return requests({url:'/manage/editroles',data,method:'put'})
}
//删除角色信息
export const delRoles= (id) =>{
return requests({url:`/manage/delroles/${id}`,method:'delete'})
}
//保存角色所选的菜单权限权力
export const savePowerRoles= ({data}) =>{
return requests({url:'/manage/saverightsroles',data,method:'post'})
}
/*文章管理*/
//获取列表数据
export const getArticle= ({params}) =>{
return requests({url:'/manage/list',params,method:'get'})
}
//增加列表数据
export const addArtcate= ({data}) =>{
return requests({url:'/manage/add',data,method:'post'})
}
//根据id删除列表数据
export const delArticle= (id) =>{
return requests({url:`/manage/delete/${id}`,method:'delete'})
}

//根据id获取列表数据
export const byIdArticle= (id) =>{
return requests({url:`/manage/${id}`,method:'get'})
}
/*用户资源下载统计*/
export const getUserAllList= () =>{
return requests({url:'/manage/userAllList',method:'get'})
}

//根据id更新列表数据
export const uPbyIdArticle= ({data}) =>{
return requests({url:'/manage/edit',data,method:'put'})
}
/*评论管理*/
//评论展示
export const getComments= (id) =>{
return requests({url:`/comment/commentlist/${id}`,method:'get'})
}
//发表评论
export const addComments= ({data}) =>{
return requests({url:'/comment/addcomment',data,method:'post'})
}
/*公共服务平台*/
export const getZyList= ({params}) =>{
return requests({url:'/service/zy',params,method:'get'})
}
//上传文件
export const addZy= ({data},config) =>{
return requests({url:'/service/zy/add',data,timeout: 60000,method:'post',...config})
}
//根据id获取数据
export const byIdZy= (id) =>{
return requests({url:`/service/zy/byid/${id}`,method:'get'})
}
//根据id更新数据
export const uPbyIdZy= ({data}) =>{
return requests({url:'/service/zy/update',data,method:'put'})
}

//根据id删除列表数据
export const delZy= (id) =>{
return requests({url:`/service/zy/delete/${id}`,method:'delete'})
}
/*供应链*/
export const getSupplyList= ({params}) =>{
return requests({url:'/supply/socksupply',params,method:'get'})
}
//增加数据
export const addSupply= ({data}) =>{
return requests({url:'/supply/addsupply',data,method:'post'})
}
//根据id删除列表数据
export const delSupply= (id) =>{
return requests({url:`/supply/deletesupply/${id}`,method:'delete'})
}
//根据id获取数据
export const byIdSupply= (id) =>{
return requests({url:`/supply/sockssupply/${id}`,method:'get'})
}
//根据id更新数据
export const uPbyIdSupply= ({data}) =>{
return requests({url:'/supply/updatesupply',data,method:'put'})
}
//******订单*********
//获取列表
export const getOrderList= ({params}) =>{
return requests({url:'/supply/order',params,method:'get'})
}
//新增
export const addorder= ({data}) =>{
return requests({url:'/supply/addorder',data,method:'post'})
}
//删除
export const delOrder= (id) =>{
return requests({url:`/supply/deleteorder/${id}`,method:'delete'})
}
//根据id获取数据
export const byIdOrder= (id) =>{
return requests({url:`/supply/order/${id}`,method:'get'})
}
//根据id更新数据
export const uPbyIdOrder= ({data}) =>{
return requests({url:'/supply/updateorder',data,method:'put'})
}

//*****供应链实际产能***********
export const getActualList= ({params}) =>{
return requests({url:'/supply/actual',params,method:'get'})
}
/*图表echart*/
export const getCountList= () =>{
return requests({url:'/statistics/count',method:'get'})
}




//**************注册发邮件****************

export const sendEmail= (data) =>{
return requests({url:'/api/sendemail',data,method:'post'})
}
